<script>
import Layout from '@layouts/main';
import CarTypeForm from '@views/carTypes/form';
import beforeLeaveAfterEdit from '@mixins/beforeLeaveAfterEdit';

export default {
  name: 'CarTypeEdit',
  components: {
    Layout,
    CarTypeForm,
  },
  mixins: [beforeLeaveAfterEdit],
  page() {
    return {
      title: `${this.$t('titles.edit_car_type')} #${this.$route.params.id}`,
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('titles.home'),
          to: { name: 'home.index' },
        },
        {
          text: this.$t('titles.car_types'),
          to: { name: 'carTypes.index' },
        },
        {
          text: `${this.$t('titles.edit_car')} #${this.$route.params.id}`,
          active: true,
        },
      ],
    };
  },
  methods: {
    update(callback) {
      this.setUnchanged();
      if (!callback) {
        this.$router.push({
          name: 'carTypes.index',
        });
      }
    },
  },
};
</script>

<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbItems" />
    <b-card
      :border-variant="!errors.items.length ? 'dark' : 'danger'"
      :header="$t('titles.edit_car_type')"
      header-tag="header"
      :header-bg-variant="!errors.items.length ? 'dark' : 'danger'"
      header-text-variant="white"
      class="mb-3"
    >
      <CarTypeForm :loaded-id="$route.params.id" @submitted="update" @entity-changed="initBeforeLeave" />
    </b-card>
  </Layout>
</template>
